// Sistem Performansı ortak yardımcıları
export const fmtMs = (v) => (v == null ? '—' : v >= 1000 ? `${(v / 1000).toLocaleString('tr-TR', { maximumFractionDigits: 2 })} sn` : `${v.toLocaleString('tr-TR', { maximumFractionDigits: v < 10 ? 1 : 0 })} ms`);
export const fmtNum = (v) => (v == null ? '—' : v.toLocaleString('tr-TR'));
export const fmtPct = (v) => (v == null ? '—' : `%${v.toLocaleString('tr-TR', { maximumFractionDigits: 2 })}`);
export const fmtTime = (iso, range) => {
  const d = new Date(iso);
  return range === '30d' || range === '7d' ? d.toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
};
export const RANGES = [['1h', 'Son 1 saat'], ['24h', 'Son 24 saat'], ['7d', 'Son 7 gün'], ['30d', 'Son 30 gün']];

export const Delta = ({ now, prev, lowerIsBetter = true, testId }) => {
  if (now == null || prev == null || prev === 0) return <span className="text-xs text-slate-400" data-testid={testId}>önceki dönem verisi yok</span>;
  const d = ((now - prev) / prev) * 100;
  const good = lowerIsBetter ? d <= 0 : d >= 0;
  return <span className={`text-xs font-medium ${Math.abs(d) < 5 ? 'text-slate-500' : good ? 'text-emerald-600' : 'text-rose-600'}`} data-testid={testId}>{d > 0 ? '+' : ''}{d.toFixed(0)}% önceki döneme göre</span>;
};

export const Kpi = ({ label, value, sub, testId }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid={testId}>
    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</p>
    <p className="mt-1 text-2xl font-semibold tabular-nums text-slate-900" data-testid={`${testId}-value`}>{value}</p>
    <div className="mt-1 min-h-[16px]">{sub}</div>
  </div>
);
